import Repository from 'helpers/Repository';
import BaseMessageHandler from '../BaseMessageHandler';

export default class PaymentOperation_PreFilledPayout extends BaseMessageHandler {
  success = () => {
    const { history, message } = this;
    const { payload } = message;
    const isOldMenu =
      Repository.get('store').getState().layoutConfiguration.menuVersion ===
      'old';
    const basePath = isOldMenu ? '/manual-payments' : '/payouts';

    history.push({
      pathname: `${basePath}/single-payout-form`,
      state: { data: payload, preFilled: true },
    });
  };
}
